import "./modules/lite-yt-embed";
import LazyLoad from "./modules/LazyLoad";
import {
  MediaCarousel,
  MediaCarouselNavigation,
} from "./components/MediaCarousel";
// import { ProductGallery, ProductThumbnails } from "./components/ProductGallery";
import { TabPanels } from "./components/FeaturedCollections";
import ProductScale from "./components/ProductScale";
import CustomRangeSlider from "./components/CustomRangeSlider";
import StickyAddToCart from "./components/StickyAddToCart";
import AccordionDropdown from "./components/AccordionDropdown";

new LazyLoad();
new MediaCarousel();
new MediaCarouselNavigation();
new TabPanels();
new ProductGallery();
new ProductThumbnails();
new ProductScale();
new CustomRangeSlider();
new StickyAddToCart();
new AccordionDropdown();
